import React from "react";
import "./SplashPanel.css";
import {Button} from "reactstrap";
import TextLabel from "../../Controls/TextLabel.mjs";
import CustomerIcon from "../../Controls/CustomerIcon.mjs";
import VSwitch from "../../Controls/VSwitch.mjs";
import AppIcon from "../../media/images/AppIcon.mjs";
import AppFullLogo from "../../media/images/AppFullLogo.mjs";
import HermesBayLogo from "../../media/images/HermesBayLogo.mjs";

const G = window.glob;

const SplashPanel = class extends React.Component {
	render() {
		return (
			<div className={"SplashPanel"}>
				<CustomerIcon />
				<div className={"image"}>
					<div className={"logos"}>
						<div>
							<HermesBayLogo/>
						</div>
						<div>
							<AppFullLogo/>
						</div>
					</div>
					<div className={"icon"}>
						<AppIcon />
					</div>
				</div>
				<div className={"comment"}>
					<div className={"StorageSelector"}>
						<VSwitch
							current={ G.prop.storageCanPersist }
							items={[
								{ value: false, label: <TextLabel value={"PublicComputer"}/> },
								{ value: true, label: <TextLabel value={"PrivateComputer"}/> },
							]}
							onChange={ (x)=>{
								G.setStoragePersistence( x.value );
							}}
						/>
					</div>
					<Button
						color={"primary"}
						className={"btn-icon"}
						onClick={ this.props.onChange }
					>
						<b><TextLabel value={"Start"}/></b>
						<i><TextLabel value={"forward"} lang={"icon"}/></i>
					</Button>
				</div>
			</div>
		);
	}
}

export default SplashPanel;